import { createContext, useContext } from 'react';
/**
 * __Avatar context__
 *
 * This allows setting the size of all avatars under a context provider.
 *
 * ```tsx
 * <AvatarContext.Provider value={{ size: 'small' }}>
 *   <Avatar
 *     // ...props
 *   />
 * </AvatarContext.Provider>
 * ```
 */
export var AvatarContext = /*#__PURE__*/createContext(undefined);
export var useAvatarContext = function useAvatarContext() {
  return useContext(AvatarContext);
};